<template>
  <div class="pt-7 flex justify-center">
    <div class="bg-white shadow-md rounded-xl px-8 pt-6 pb-8 mb-4 flex flex-col w-11/12 md:w-3/4">
      <div class="-mt-6 -ml-8 -mr-8 rounded-t-xl bg-sky-500 pt-4 pl-6 md:pl-8">
        <div class="leading-none tracking-tight mb-3 md:mb-4 text-2xl md:text-3xl text-gray-50">Welcome to Screened</div>
      </div>

      <div class="mt-8 flex flex-col md:flex-row justify-center items-center gap-8">
        <!-- Contractor Card -->
        <div class="w-full md:w-1/2 bg-gradient-to-r from-sky-50 to-indigo-50 rounded-lg p-6 shadow-sm hover:shadow-md transition-all duration-300">
          <div class="flex flex-col items-center">
            <div class="text-lg font-semibold text-gray-800 mb-2">I'm a Contractor</div>
            <p class="text-gray-600 text-sm mb-6 text-center">Find great opportunities with top companies</p>
            <div class="space-y-3">
              <router-link to="/contractor/login" class="group relative inline-flex items-center overflow-hidden rounded-full bg-sky-500 px-8 py-3 text-white focus:outline-none focus:ring active:bg-sky-600 w-full justify-center">
                <span class="text-sm font-medium transition-all group-hover:me-4">
                  Login
                </span>
                <span class="absolute -end-full transition-all group-hover:end-4">
                  →
                </span>
              </router-link>
              <router-link to="/contractor/register" class="group relative inline-flex items-center overflow-hidden rounded-full border-2 border-sky-500 px-8 py-3 text-sky-500 hover:bg-sky-50 focus:outline-none focus:ring w-full justify-center">
                <span class="text-sm font-medium">
                  Register
                </span>
              </router-link>
            </div>
          </div>
        </div>

        <!-- Company Card -->
        <div class="w-full md:w-1/2 bg-gradient-to-r from-sky-50 to-indigo-50 rounded-lg p-6 shadow-sm hover:shadow-md transition-all duration-300">
          <div class="flex flex-col items-center">
            <div class="text-lg font-semibold text-gray-800 mb-2">I'm a Company</div>
            <p class="text-gray-600 text-sm mb-6 text-center">Access our talented pool of contractors</p>
            <div class="space-y-3">
              <router-link to="/company/login" class="group relative inline-flex items-center overflow-hidden rounded-full bg-sky-500 px-8 py-3 text-white focus:outline-none focus:ring active:bg-sky-600 w-full justify-center">
                <span class="text-sm font-medium transition-all group-hover:me-4">
                  Login
                </span>
                <span class="absolute -end-full transition-all group-hover:end-4">
                  →
                </span>
              </router-link>
              <router-link to="/company/register" class="group relative inline-flex items-center overflow-hidden rounded-full border-2 border-sky-500 px-8 py-3 text-sky-500 hover:bg-sky-50 focus:outline-none focus:ring w-full justify-center">
                <span class="text-sm font-medium">
                  Register
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- Optional Feature Section -->
      <div class="mt-12 text-center">
        <div class="relative">
          <div class="absolute inset-0 flex items-center">
            <div class="w-full border-t border-gray-200"></div>
          </div>
          <div class="relative flex justify-center">
            <span class="bg-white px-4 text-sm text-gray-500">Why choose Screened</span>
          </div>
        </div>

        <div class="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div class="p-4">
            <div class="text-sky-500 font-semibold mb-2">For Contractors</div>
            <p class="text-gray-600 text-sm">Connect with top companies and find your next opportunity</p>
          </div>
          <div class="p-4">
            <div class="text-sky-500 font-semibold mb-2">For Companies</div>
            <p class="text-gray-600 text-sm">Access a curated pool of talented contractors</p>
          </div>
          <div class="p-4">
            <div class="text-sky-500 font-semibold mb-2">Smart Matching</div>
            <p class="text-gray-600 text-sm">Our AI-powered platform ensures the perfect fit</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import BigCard from '@/components/BigCard'

export default {
  name: 'Home',
  components: {
    BigCard,
  },
  metaInfo: {
    title: 'Screened - Connecting Top Talent with Great Opportunities'
  }
}
</script>
